import MUIDataTable from "mui-datatables";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { Avatar, Box, Button, Switch, TableRow } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Fade from "@mui/material/Fade";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import { SettingsSystemDaydream } from "@mui/icons-material";
import {
  TableCell,
  TableBody,
  TableHead,
  Table,
  TableContainer,
} from "@mui/material";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const axios = require("axios");

// const api = axios.create({
//     baseURL: "http://localhost:5000/api/"
// })

const OffBatchList = () => {
  const api = useAxiosPrivate();
  const [batchState, setBatchState] = useState([]);
  const navigate = useNavigate();
  const isGraduate = [];
  const [graduate, setGraduate] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [deleteId, setDeleteId] = useState([]);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [open, setOpen] = useState(false);
  const [sem, setSem] = useState([]);
  const [course, setCourse] = useState([]);

  const handleClose = () => {
    setDialog(false);
  };
  let amt = [];

  const handleDelete = async () => {
    console.log(deleteId);
    for (let i = 0; i < deleteId.length; i++) {
      const result = await api.delete(`deleteBatch/${deleteId[i]}`);
      console.log(result);
      setOpen(true);
    }
    setDeleteAlert(true);
    setDialog(false);
  };

  const handleToggle = async (index, event) => {
    console.log(index);
    isGraduate[index - 1] = event.target.checked;
    console.log(isGraduate[index - 1]);
    const result2 = await api.put(`/updateGraduate/${index}`, {
      isGraduate: isGraduate[index - 1],
    });

    setGraduate(isGraduate);
  };

  const getCourse = async (id) => {
    const course = [];
    const data = await api.get(`/getOffBatchCourse`);

    for (const c of data.data) {
      const d = await api.get(`getCourse/${c.course_code}`);
      console.log(d);
      course.push({ ...c, ...d.data[0] });
    }
    setCourse(course);
  };

  const getBatch = async (req, res) => {
    let b = [];
    let amount = [];
    let arr = [];

    const currentBatches = await api.get("/getBatch");

    let arr1 = [];
    for (const c of currentBatches.data) {
      let sum = 0;
      const result = await api.get(`howManySection/${c.id}`);

      for (let i = 0; i < result.data.length; i++) {
        sum = sum + result.data[i].no_of_students;
      }
      arr.push(sum);
      amount.push(result);
      const sems = await api.get(`getOneSemester/${c.semester_id}`);
      const start_date = sems.data[0].start_date.substring(
        0,
        sems.data[0].start_date.indexOf("T")
      );
      // const start = value.data[i].start_date.substring(0,value.data[0].start_date.indexOf("T"))
      arr1.push({ ...sems, start: start_date });
    }
    setSem(arr1);

    for (let i = 0; i < currentBatches.data.length; i++) {
      const result = await api.get(
        `getDepartment/${currentBatches.data[i].department}`
      );

      b.push({
        ...currentBatches.data[i],
        department: result.data[0].name,
        dept_id: result.data[0].id,
        // graduate:currentBatches.data[i].isGraduate.toString(),
        numOfSec: amount[i].data.length,
        no_of_students: arr[i],
        isOffBatch: currentBatches.data[i].isOffBatch.toString(),
      });
    }
    const batch = b.filter((c) => c.isOffBatch === "true");
    setBatchState(batch);
    //    return batchState;
  };

  const data = batchState;
  const columns = [
    { label: "id", name: "id", options: { display: false, filter: false } },
    { label: "batch year", name: "batch_year" },
    { label: "program type", name: "program_type" },
    { label: "Admission type", name: "admission_type" },
    { label: "Year", name: "year" },
    { label: "number of students", name: "no_of_students" },
    { label: "number of sections", name: "numOfSec" },
    { label: "department", name: "department" },
    { label: "off batch", name: "isOffBatch" },
    {
      label: "department_id",
      name: "dept_id",
      options: { display: "none", filter: "false" },
    },
    // {
    //   label: "graduate",
    //   name: "graduate",
    //   options: { filter: "true", display: "none" },
    // },
    {
      label: "Action",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (dataIndex, rowIndex, tableMeta, value) => {
          return (
            <div
              style={{ width: "100px", display: "flex", alignItems: "center" }}
            >
              {/* <NavLink to={`/`} onClick={(e)=>{
                            navigate(`/update`,{state : {updateId : data[rowIndex.rowIndex]}})
                            setUpdateId(data[rowIndex.rowIndex].id,e)
                        // console.log(data[rowIndex.rowIndex].id)
                            }}> */}
              <Button
                onClick={() =>
                  navigate("/batch_management/update", {
                    state: { updateId: rowIndex.rowData[0] },
                  })
                }
              >
                <EditIcon color="primary" />
              </Button>
              {/* </NavLink> */}
              {/* <Switch checked={isGraduate[data[rowIndex.rowIndex].id]}
                        onChange={ 
                            async (e)=>{
                                handleToggle(data[rowIndex.rowIndex].id,e)
                            }
                                
                            }
                        ></Switch> */}
            </div>
          );
        },
      },
      name: "delete",
    },
  ];

  const options = {
    filterType: "checkbox",
    onRowsDelete: async (rowsDeleted) => {
      let amt = [];
      const idsToDelete = rowsDeleted.data.map((d) => data[d.dataIndex]);
      for (let i = 0; i < idsToDelete.length; i++) {
        amt.push(idsToDelete[i].id);
      }
      setDeleteId(amt);
      setDialog(true);
    },
    expandableRows: true,
    expandableRowsHeader: false,
    renderExpandableRow: (rowData, rowMeta) => {
      console.log(course[0].batch_id, rowData[0]);
      const c = course.filter((c) => c.batch_id === rowData[0]);
      const colSpan = 3;
      return (
        <tr >
          <td colSpan = {colSpan}>
            <TableContainer sx={{ml : 10}}> 
              <Table>
                <TableRow>
                  <TableCell>course name</TableCell>
                  <TableCell>course code</TableCell>
                </TableRow>
                {c.map((c) => {
                  return (
                    <TableRow>
                      <TableCell>{c.course_name}</TableCell>
                      <TableCell>{c.course_code}</TableCell>
                    </TableRow>
                  );
                })}
              </Table>
            </TableContainer>
          </td>
        </tr>
      );
    },
    // renderExpandableRow: (rowData, rowMeta) => {
    //   console.log(rowMeta, sem[rowMeta.rowIndex]);
    //   const colSpan = rowData.length + 1;
    //   return (
    //     <tr>
    //       <td colSpan={colSpan}>
    //         <TableContainer sx={{ backgroundColor: "#ADD8E6" }}>
    //           <Table>
    //             <TableRow>
    //               <TableCell> academic year</TableCell>
    //               <TableCell> semester Term</TableCell>
    //               <TableCell> start date </TableCell>
    //               <TableCell> number of weeks</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>
    //                 {" "}
    //                 {sem[rowMeta.rowIndex].data[0].academic_year}
    //               </TableCell>
    //               <TableCell>
    //                 {" "}
    //                 {sem[rowMeta.rowIndex].data[0].semester_term}
    //               </TableCell>
    //               <TableCell> {sem[rowMeta.rowIndex].start}</TableCell>
    //               <TableCell>
    //                 {" "}
    //                 {sem[rowMeta.rowIndex].data[0].no_weeks}
    //               </TableCell>
    //             </TableRow>
    //           </Table>
    //         </TableContainer>
    //       </td>
    //     </tr>
    //   );
    // },
  };
  useEffect(() => {
    getBatch();
    getCourse();
    console.log("i fire once");
  }, [open]);


  return (
    <div>
      {/* <SideBar /> */}
      <Dialog open={dialog} onClose={handleClose}>
        <DialogTitle>{"Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            are you sure you want to delete these section
          </DialogContentText>
          <DialogActions>
            <div>
              <Button onClick={handleDelete}>ok</Button>
              <Button onClick={handleClose}>cancel</Button>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <MUIDataTable
        title={"Off Batch List"}
        data={data}
        columns={columns}
        options={options}
      />
      <Stack sx={{ width: "100%" }} spacing={2}>
        <Fade
          in={deleteAlert}
          timeout={{ enter: 1000, exit: 1000 }}
          addEndListener={() => {
            setTimeout(() => {
              setDeleteAlert(false);
            }, 6000);
          }}
        >
          <Alert>
            <AlertTitle>success</AlertTitle>
            successfully deleted
          </Alert>
        </Fade>
      </Stack>
    </div>
  );
};

export default OffBatchList;
